module.exports = __webpack_public_path__ + "static/media/robert-lamb-5398-unsplash.471eba2b.jpg";